export default "__VITE_PUBLIC_ASSET__6007c55b__"